import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Partner } from 'src/app/shared/models/partner';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { MoveShowModalComponent } from '../../_modals/move-show-modal/move-show-modal.component';
import { Show } from 'src/app/shared/models/show';
import { PartnerGroup } from 'src/app/shared/models/partner-group';

@Component({
  selector: 'app-pro-partner-show-content',
  templateUrl: './pro-partner-show-content.component.html',
  styleUrls: ['./pro-partner-show-content.component.scss']
})
export class ProPartnerShowContentComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  dataSource: MatTableDataSource<any>;

  //table headers
  displayedColumns = ['show', 'seasons', 'action']



  //shows display data (only shows for partner)
  shows: any[] = [];

  //represents the selected partner
  partner: Partner;

  //all partner groups the selected partner is a member of
  partnerGroups: PartnerGroup[];

  constructor(private partnerService: PartnerService, private route: ActivatedRoute, private snackbarService: SnackBarService, public dialog: MatDialog) { }

  ngOnInit() {

    //track partner
    this.partnerService.selectedPartner$.subscribe((x) => {
      this.partner = x;

      // Sort this.partner.shows by id in descending order
      //this way, the newly added shows appear at the top
      //of the list in the UI
      this.partner.shows.sort((a, b) => b.id - a.id);

      //reset
      this.shows = [];

      //get shows for partner
      this.partner.shows.forEach(show => {
        const showDetails = {
          id: show.id,
          show: show.name,
          seasons: show.seasons,
          seasonsCount: show.seasons.length,
          expandDetails: false
        };

        this.shows.push(showDetails);
      })

      this.dataSource = new MatTableDataSource(this.shows);
    });

    //track partner groups
    this.partnerService.partnerGroups$.subscribe((x) => {
      this.partnerGroups = x;
    })

    
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }


  moveShow(show: Show) {
    const dialogRef = this.dialog.open(MoveShowModalComponent, {
      // width: '800px',
      // height: '400px',
      data: { showId: show.id } // If you need to pass data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

    /**
   * Called when the drop down arrow is selected
   * Shows or hides show details
   * @param element 
   */
    toggleDetails(element: any) {

      element.expandDetails = !element.expandDetails;
  
    }

      /**
   * Used with ngClass to modify UI styling when a row's
   * expandedDetails are show
   * @param element 
   * @returns 
   */
  styleExpandedDetailsRow(element: any): boolean {

    //test hidden
    return element.expandDetails;
  }

  


}
